/**
 * Labstep
 */

import { getMetadataColDefs } from 'labstep-web/grid/Index/coldefs/Resource/metadatas';
import { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';

/**
 * For all metadatas on resource template, return a column
 * @param resourceTemplate Resource template
 * @returns Column definitions
 */
export const getResourceItemResourceMetadataColDefs = (
  resourceTemplate: Resource,
) =>
  getMetadataColDefs<ResourceItem>(
    Resource.entityName,
    resourceTemplate,
    (params) => params.data.resource,
    {
      entityName: ResourceItem.entityName,
      childEntityName: Resource.entityName,
    },
  );
